import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Criteria/WeightedScores/Domain/queries';
import Component from 'vue-class-component';

@Component
export default class WeightedScoresQueries extends VueCqrs
{
	runWeightedScoresPageQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildWeightedScoresPageQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runBlankWeightedScoreSettingsQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildBlankWeightedScoreSettingsQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runWeightedScoreSettingsByIdQueryV1(workspaceId: number, projectId: number, evalModelId: number, weightedScoreId: string)
	{
		const query = q.buildWeightedScoreSettingsByIdQueryV1(workspaceId, projectId, evalModelId, weightedScoreId);
		this.$query(query);
	}

	runWeightedScoreSettingsByAttributeIdQueryV1(workspaceId: number, projectId: number, attributeId: number)
	{
		const query = q.buildWeightedScoreSettingsByAttributeIdQueryV1(workspaceId, projectId, attributeId);
		this.$query(query);
	}
}
